import React, { useState, forwardRef } from 'react'
import propTypes from 'prop-types'

import { Tooltip } from '@components/Tooltip'
import { appColors } from '../../globalStyles'
import { hexToRGBA } from '@utils/colorConversions'

export const Spotlight = forwardRef(
  ({interactive, onClick, value, description, color, bold, dashed, subtext, tooltipProps, ...rest}, ref
  ) => {
  const [active, setActive] = useState(true)

  const className = constructClassNameFromProps({ interactive, ...rest }, active)

  const onSpotlightClick = () => {
    onClick && onClick(!active)
    if (interactive) {
      setActive(!active)
    }
  }

  const spotlightValue = (
    <h3 className='flex flex-col'>
      { value }
      { subtext && <small className='relative top-1' style={{ color: hexToRGBA(appColors.red, 0.7) }}>{subtext}</small> }
    </h3>
  )
  const spotlightValueWithTooltip = tooltipProps ? <Tooltip {...tooltipProps}>{spotlightValue}</Tooltip> : spotlightValue

  return (
    <div
      {...rest}
      ref={ref}
      onClick={onSpotlightClick}
      className={className} >
      <div>
        {spotlightValueWithTooltip}
      </div>
      <hr
        style={{
          borderBottomColor: color,
          borderBottomWidth: bold ? '3px' : '1px',
          borderBottomStyle: dashed ? 'dashed' : 'solid'
        }}
      />
      <p>{description}</p>
    </div>
  )
})

const constructClassNameFromProps = (props, active) =>
  `spotlight ${props.interactive ? 'interactive' : ''} ${props.className ? props.className : ""} ${active ? 'active' : 'inactive'}`

Spotlight.propTypes = {
  value: propTypes.oneOfType([propTypes.number, propTypes.string]).isRequired,
  description: propTypes.string.isRequired,

  className: propTypes.string,
  color: propTypes.string,
  bold: propTypes.bool,
  dashed: propTypes.bool,
  subtext: propTypes.string,

  tooltipProps: propTypes.object
}
